module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "600",
      "height": "600"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5a5048c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Canvas.vue
// module id = 125
// module chunks = 1